<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>评价服务</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box pro-detail__wraper">
            <div class="table" style="padding: 20px">
                <el-table
                    :data="data"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        prop="sub_no"
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="member_name"
                        align="center"
                        label="服务人员">
                    </el-table-column>
                    <el-table-column
                        prop="service_count"
                        align="center"
                        label="服务数量">
                    </el-table-column>
                </el-table>
            </div>
            <div class="eva-form">
                <div class="eva-form__item rates-wrapper">
                    <div class="rate-box">
                        <div class="label"> <span class="text-danger">*</span> 项目效率</div>
                        <div class="value">
                            <el-rate
                                v-model="formItem.efficiency"
                                show-score
                                allow-half
                                score-template="{value}分">
                            </el-rate>
                        </div>
                    </div>
                    <div class="rate-box">
                        <div class="label"> <span class="text-danger">*</span> 项目质量</div>
                        <div class="value">
                            <el-rate
                                v-model="formItem.quality"
                                show-score
                                allow-half
                                score-template="{value}分">
                            </el-rate>
                        </div>
                    </div>
                    <div class="rate-box">
                        <div class="label"> <span class="text-danger">*</span> 项目经济</div>
                        <div class="value">
                            <el-rate
                                v-model="formItem.economy"
                                show-score
                                allow-half
                                score-template="{value}分">
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="eva-form__item text-area__box" style="align-items: stretch">
                    <div class="label"> <span class="text-danger">*</span> 评价服务</div>
                    <div class="text-wrapper">
                        <el-input
                            type="textarea"
                            :rows="10"
                            placeholder="请填写评价内容"
                            v-model="formItem.content">
                        </el-input>
                    </div>
                </div>
                <div class="eva-form__item text-area__box">
                    <div class="label"></div>
                    <div class="text-wrapper">
                        <el-button @click="onSubmit" type="primary" style="min-width: 144px; font-size: 14px;">提交评价</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '../../router'
import qs from 'qs'

export default {
    name: 'Evaluate',
    data () {
        return {
            data: [],
            tags: [],
            formItem: {
                economy: 0,
                efficiency: 0,
                quality: 0,
                content: ''
            }
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
    },
    methods: {
        getInfo (id, sub_id) {
            this.$http.get('/api/user/project/appraise', {
                params: {
                    id,
                    sub_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.data = [res.data]
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        onSubmit () {
            if (this.formItem.capacity === 0) {
                this.$message.error('请对服务人员的业务能力评分')
            } else if (this.formItem.work_efficiency === 0) {
                this.$message.error('请对服务人员的工作效率评分')
            } else if (this.formItem.attitude === 0) {
                this.$message.error('请对服务人员的工作态度评分')
            } else if (this.formItem.content.length < 2 || this.formItem.content.length > 100) {
                this.$message.error('请填写2-100字的评价内容')
            } else {
                this.$http.post('/api/user/project/appraisesubmit', qs.stringify({
                    id: this.$route.query.id,
                    sub_id: this.$route.query.sub_id,
                    economy: this.formItem.economy,
                    efficiency: this.formItem.efficiency,
                    quality: this.formItem.quality,
                    content: this.formItem.content
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '评价已提交'
                            })
                            router.replace(`/index/member/personal?id=${res.data.member_id}`)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .eva-form {
        font-size: 14px;
        margin-top: 54px;
        padding: 0 20px;
        .eva-form__item {
            margin-bottom: 34px;
        }
        .rates-wrapper {
            display: flex;
            .rate-box {
                display: flex;
                align-items: center;
                width: 280px;
                margin-right: 56px;
            }
        }
        .text-area__box {
            display: flex;
            align-items: center;
            .text-wrapper {
                flex: 1;
            }
        }
        .label {
            position: relative;
            padding-left: 10px;
            margin-right: 20px;
            top: 1px;
            width: 90px;
            text-align: right;
            overflow: hidden;
            .text-warning {
                font-size: 20px;
                position: absolute;
                top: 1px;
                left: 0;
            }
        }
    }
</style>
